import en from '~/utils/translations/DiscussionForums/en';
import zh from '~/utils/translations/DiscussionForums/zh';
import nl from '~/utils/translations/DiscussionForums/nl';
import fi from '~/utils/translations/DiscussionForums/fi';
import fr from '~/utils/translations/DiscussionForums/fr';
import de from '~/utils/translations/DiscussionForums/de';
import hi from '~/utils/translations/DiscussionForums/hi';
import it from '~/utils/translations/DiscussionForums/it';
import ja from '~/utils/translations/DiscussionForums/ja';
import ko from '~/utils/translations/DiscussionForums/ko';
import pl from '~/utils/translations/DiscussionForums/pl';
import pt from '~/utils/translations/DiscussionForums/pt';
import es from '~/utils/translations/DiscussionForums/es';
import tr from '~/utils/translations/DiscussionForums/tr';
import vi from '~/utils/translations/DiscussionForums/vi';
import ar from '~/utils/translations/DiscussionForums/ar';

export default {
    en,
    zh,
    nl,
    fi,
    fr,
    de,
    hi,
    it,
    ja,
    ko,
    pl,
    pt,
    es,
    tr,
    vi,
    ar,
};
